import { AnimalIcon, BlanketIcon, BooksIcon, GameControllerIcon, GuitarIcon, HoodieIcon, PhoneCaseIcon, PillowIcon, SmileyFaceIcon, SportsIcon, StickersIcon, TshirtIcon, TvIcon, VideoCameraIcon, WallArtIcon, } from './icons';
import { messages } from './messages';
export var config = {
    topics: [
        {
            label: messages.music,
            Icon: GuitarIcon,
            category: { topic: 'music' },
        },
        {
            label: messages.television,
            Icon: TvIcon,
            category: { topic: 'television' },
        },
        {
            label: messages.animals,
            Icon: AnimalIcon,
            category: { topic: 'animals' },
        },
        {
            label: messages.movies,
            Icon: VideoCameraIcon,
            category: { topic: 'movies' },
        },
        {
            label: messages.gaming,
            Icon: GameControllerIcon,
            category: { topic: 'gaming' },
        },
        {
            label: messages.books,
            Icon: BooksIcon,
            category: { topic: 'books' },
        },
        {
            label: messages.sports,
            Icon: SportsIcon,
            category: { topic: 'sports' },
        },
        {
            label: messages.funny,
            Icon: SmileyFaceIcon,
            category: { topic: 'funny' },
        },
    ],
    products: [
        {
            label: messages.tShirts,
            Icon: TshirtIcon,
            category: { product: 't-shirts' },
        },
        {
            label: messages.stickers,
            Icon: StickersIcon,
            category: { product: 'stickers' },
        },
        {
            label: messages.wallArt,
            Icon: WallArtIcon,
            category: { product: 'prints' },
        },
        {
            label: messages.blankets,
            Icon: BlanketIcon,
            category: { product: 'blankets' },
        },
        {
            label: messages.hoodies,
            Icon: HoodieIcon,
            category: { product: 'sweatshirts' },
        },
        {
            label: messages.pillows,
            Icon: PillowIcon,
            category: { product: 'throw-pillows' },
        },
        {
            label: messages.phoneCases,
            Icon: PhoneCaseIcon,
            category: { product: 'iphone-cases' },
        },
    ],
};
